import * as React from 'react'
import { useState } from 'react'
import MediaModal from '../sharedComponents/MediaModal'

function ImageGallery({
  content,
}: {
  content: {
    imageList: string[]
    imagePreview: string
  }
}) {
  const [open, setOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)

  const openLightbox = (index) => {
    setPhotoIndex(index)
    setOpen(true)
  }

  const movePrev = () =>
    setPhotoIndex(
      (photoIndex + content.imageList.length - 1) % content.imageList.length
    )

  const moveNext = () =>
    setPhotoIndex((photoIndex + 1) % content.imageList.length)

  return (
    <div>
      <div className="relative">
        <img
          src={content.imagePreview}
          alt="Gallery"
          className=" w-full object-cover"
          onClick={() => openLightbox(0)}
        />
        <button
          onClick={() => {
            openLightbox(0)
          }}
          className="btn btn-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        >
          Gallery
        </button>
      </div>
      {open && (
        <MediaModal setOpen={setOpen}>
          <div className="aspect-video w-full flex justify-center align-middle">
            <img
              src={content.imageList[photoIndex]}
              alt="Lightbox"
              className="object-cover w-full"
            />
          </div>
          <div
            className="absolute left-5 bottom-5
               md:left-6 md:bottom-6
               xl:left-10 xl:bottom-10
              "
          >
            <button
              onClick={movePrev}
              className="btn btn-circle-small btn-arrow-left z-[55] "
            ></button>
          </div>
          <div
            className="absolute right-5 bottom-5
           md:right-6 md:bottom-6
           xl:right-10 xl:bottom-10
           "
          >
            <button
              onClick={moveNext}
              className="btn btn-circle-small btn-arrow-right z-[55] "
            ></button>
          </div>
        </MediaModal>
      )}
    </div>
  )
}

export default ImageGallery
